type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  actionHref?: string;
};

export default function SectionHeading({ eyebrow, title, desc, actionLabel, actionHref }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-wide text-primary-600">
          <span className="h-3 w-0.5 rounded-full bg-primary-500" />
          {eyebrow}
        </span>
        <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </a>
      )}
    </div>
  );
}